<template>
  <div class="add-hemorrhage public-content">
    <div class="breadcrumb">上传元素</div>
    <div class="third-title"><span>元素</span></div>
    <div class="order-detail-basic">
      <el-form :model="elementVo" label-width="100px" ref="formRef">
        <el-form-item label="素材标签:">
          <el-checkbox-group v-model="elementVo.labelIds">
            <el-checkbox v-for="item in tageList" :key="item.id" :label="item.id">{{ item.label }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="元素:">
          <input id="update" multiple @change="uploadImg" type="file" style="display:none">
          <el-button type="primary" @click="clickInput" round>上传</el-button>
          <!-- <div>
              <div v-for="(item,index) in elementVo.elementImages" :key="item+index" style="float:left;position:relative;width:170px;height:170px;border:1px solid #000;margin:5px 5px 0 0">
                <i @click="elementVo.elementImages.splice(index,1)" style="position: absolute;top: 0;right: 0;font-size: 20px;border: 1px solid #ccc;" class="el-icon-close"></i>
                <img style="max-width:100%" :src="item" alt="">
              </div>
            </div> -->
          <div style="margin-top:10px;">
            <div class="upload_warp_img">
              <div class="upload_warp_img_div" v-for="(item, index) of elementVo.elementImages" :key="index">
                <div class="upload_img">
                  <img :src="item">
                  <!-- <el-image :src="item" :fit="contain"></el-image> -->
                </div>
                <div class="upload_warp_img_div_top">
                  <p class="upload_warp_img_div_del color-blue" @click="elementVo.elementImages.splice(index, 1)">删除图片</p>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="前端是否显示:">
          <el-switch v-model="elementVo.isShow" :active-value='1' :inactive-value='0' active-color="rgba(20, 115, 230, 1)" inactive-color="rgba(140, 140, 140, 1)">
          </el-switch>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button round type="primary" @click="add">确定</el-button>
    </div>
  </div>
</template>
<script>
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg.js'
import { labelGetLabelList, elementSetAdd } from '@/api/pms'
export default {
  name: 'add-hemorrhage',
  data () {
    return {
      awsSdk: null,
      checkList: [],
      elementVo: {
        elemType: this.$route.query.elemType,
        elementImages: [],
        isShow: 0,
        labelIds: []
      },
      searchLabelVo: {
        label: '',
        labelBelong: '',
        labelBelongCode: this.$route.query.elemType,
        page: 0
      },
      tageList: []
    }
  },
  created () {
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    this.getTaglist()
  },
  methods: {
    uploadImg (e) {
      console.log('eeeee', e.target.files)
      // let typeLock1 = false
      let typeLock = false
      let sizeLock = false
      let filesList = []
      for (let key in e.target.files) {
        console.log('key', key)
        if (key !== 'length' && key !== 'item') {
          let file = e.target.files[key]
          filesList.push(file)
        }
      }
      filesList.forEach(file => {
        console.log('filessss', file)
        // 素材标签为框边时
        // if (this.elementVo.labelIds == 150005) {
        //   if (file.type !== 'image/png') {
        //     typeLock1 = true
        //   }
        // } else {
        if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/svg+xml' && file.type !== 'application/postscript' && file.type !== ' ') {
          typeLock = true
        }
        // }
        if (file.size > 1024 * 1024 * 10) {
          sizeLock = true
        }
      })
      // if (typeLock1) {
      //   this.$message.error('请上传.png格式的图片')
      // }
      if (typeLock) {
        this.$message.error('请上传jpeg/png格式的图片')
        return
      } else if (sizeLock) {
        this.$message.error('图片大小不能超过10M')
        return
      }
      filesList.forEach(file => {
        uploadWebImg(file, this.$store.state.awsSdk.product.s3).then(res => {
          console.log('res', res)
          this.elementVo.elementImages.push(res)
        })
      })
    },
    clickInput () {
      document.getElementById('update').click()
    },
    add () {
      if (this.elementVo.labelIds.length === 0) {
        this.$message.error('未选择素材标签')
        return
      }
      if (this.elementVo.elementImages.length === 0) {
        this.$message.error('未上传元素')
        return
      }
      elementSetAdd(this.elementVo).then(res => {
        if (res.data.success) {
          this.$message.success('创建成功')
          this.$router.go(-1)
        }
      })
    },
    // 获取素材标签
    getTaglist () {
      labelGetLabelList({ pageNum: 1, pageSize: 10, searchLabelVo: this.searchLabelVo }).then(res => {
        if (res.data.success) {
          this.tageList = res.data.data.records
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

.add-hemorrhage {
  .spec-mm {
    span {
      margin-right: 10px;
    }

    .el-input {
      width: 110px;
    }

    @{deep} .el-input-group__append {
      padding: 0 15px;
    }
  }

  .link {
    width: 30px;
    height: 30px;
    border: 1px solid #dcdfe6;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    box-sizing: border-box;

    i {
      font-size: 20px;
      color: #999;
    }
  }

  .active-link {
    background: #1473e6;
    border: 1px solid #1473e6;

    i {
      color: #fff;
    }
  }
}

.upload_warp_img {
  overflow: hidden;
  display: flex;

  .upload_warp_img_div {
    width: 180px;
    margin: 0 5px;
    border: 1px solid #d2d2d2;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    height: 200px;
  }
}

.upload_img {
  flex: 1;
  position: relative;

  img {
    position: absolute;
    max-width: 100%;
    max-height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
}

.upload_warp_img_div_top {
  display: flex;
  width: 100%;
  align-items: center;
  background: #f9fafc;
  justify-content: center;
  line-height: 36px;
  border-top: 1px solid #ececec;
}

.upload_warp_img_div_del {
  padding-left: 10px;
}
</style>
